import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon", "label"]

  async copy() {
    const text = this.sourceTarget.textContent || this.sourceTarget.value
    await this.copyToClipboard(text)
  }

  async copyHtml(event) {
    const url = event.currentTarget.dataset.url
    try {
      const response = await fetch(url)
      const html = await response.text()
      await this.copyToClipboard(html)
    } catch (error) {
      console.error("Failed to fetch HTML:", error)
    }
  }

  async copyToClipboard(text) {
    try {
      // Try modern clipboard API first
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text)
      } else {
        // Fallback for HTTP or older browsers
        this.fallbackCopy(text)
      }
      this.showSuccess()
    } catch (error) {
      // Fallback if clipboard API fails (e.g., permissions)
      try {
        this.fallbackCopy(text)
        this.showSuccess()
      } catch (fallbackError) {
        console.error("Failed to copy:", fallbackError)
      }
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.top = '-9999px'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()
    document.execCommand('copy')
    document.body.removeChild(textarea)
  }

  showSuccess() {
    if (this.hasIconTarget) {
      const originalIcon = this.iconTarget.innerHTML
      this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>'
      setTimeout(() => {
        this.iconTarget.innerHTML = originalIcon
      }, 2000)
    }

    if (this.hasLabelTarget) {
      const originalLabel = this.labelTarget.textContent
      this.labelTarget.textContent = "Copied!"
      setTimeout(() => {
        this.labelTarget.textContent = originalLabel
      }, 2000)
    }
  }
}
